<h2 mat-dialog-title>Select Patient Overview</h2>

<div mat-dialog-content>
  <p>Please choose which version of the patient overview you would like to open.</p>
</div>

<div mat-dialog-actions class="version-actions">
  <button mat-stroked-button color="primary" (click)="select('old')">OLD</button>
  <button mat-flat-button color="accent" (click)="select('new')">NEW</button>
</div>

